const ACC_HIGH_RISK_SPORT_COVERAGE = 'ACCHighRiskSportCov';
const ACC_IMMEDIATE_COMPENSATION_COVERAGE = 'ACCImmediateCompensationCov';
const ACC_DEATH_COVERAGE = 'ACCDeathCov';
const TRA_CANCELLATION_COV = 'TRATopCancellationCov';
const TRA_SKIING_COV = 'TRATopSkiingCov';
const PET_HEATH_COVERAGE = 'PETHealthCov';
const PET_HEATH_PLUS_COVERAGE = 'PETHealthPlusCov';
const PET_LIFE_COVERAGE = 'PETLifeCov';
const PET_EXTENDED_LIABILITY_COVERAGE = 'PETExtendedLiabilityCov';
const CHO_STANDARD_COVERAGE = 'CHOStandardCov';
const CHO_EXTENDED_COVERAGE = 'CHOExtendedCov';
const PRH_PRIVATE_CONTENT_COV = 'PRHPrivateContentCov';
const PRH_ROT_AND_INSECTS_COV = 'PRHRotAndInsectsCov';
const PRH_WATER_DAMAGE_COV = 'PRHWaterDamageCov';
const UVP_ROAD_ASSISTANCE_COV = 'UVPRoadAssistanceCov';
const UVP_CONTENT_COV = 'UVPContentCov';
const MVPCOMPREHENSIVE_COV = 'MVPComprehensive';
const UVPCOMPREHENSIVETRAILER_COV = 'UVPComprehensiveTrailerCov';
const PRH_LIABILITY_COV = 'PRHLiabilityCov';
const PRH_PESTS_COV = 'PRHPestsCov';
const UVPCOMPREHENSIVE_COV = 'UVPComprehensiveCov';
const PRC_GLASS_SANITATION_COV = 'PRCGlassSanitationCov';
const PRC_EXTENDED_ELECTRONIC_COV = 'PRCExtendedElectronicCov';
const TRA_TOP_CANCELLATION_COV = 'TRATopCancellationCov';
const TRAVEL_TYPE_HOUSEHOLD = 'TravelTypeHousehold';
const AREA_DESTINATION_WORLDWIDE = 'AreaDestinationWorldwide';
const AREA_DESTINATION_ONLY_EUROPE = 'AreaDestinationOnlyEurope';
const MVPLEASINGCARRETURN = 'MVPLeasingcarReturn';

export {
    ACC_HIGH_RISK_SPORT_COVERAGE,
    ACC_IMMEDIATE_COMPENSATION_COVERAGE,
    ACC_DEATH_COVERAGE,
    TRA_CANCELLATION_COV,
    TRA_SKIING_COV,
    PET_HEATH_COVERAGE,
    PET_HEATH_PLUS_COVERAGE,
    PET_LIFE_COVERAGE,
    PET_EXTENDED_LIABILITY_COVERAGE,
    MVPCOMPREHENSIVE_COV,
    CHO_STANDARD_COVERAGE,
    CHO_EXTENDED_COVERAGE,
    PRH_PRIVATE_CONTENT_COV,
    PRH_ROT_AND_INSECTS_COV,
    PRH_WATER_DAMAGE_COV,
    UVP_ROAD_ASSISTANCE_COV,
    UVP_CONTENT_COV,
    UVPCOMPREHENSIVETRAILER_COV,
    PRH_LIABILITY_COV,
    PRH_PESTS_COV,
    UVPCOMPREHENSIVE_COV,
    PRC_GLASS_SANITATION_COV,
    PRC_EXTENDED_ELECTRONIC_COV,
    TRA_TOP_CANCELLATION_COV,
    TRAVEL_TYPE_HOUSEHOLD,
    AREA_DESTINATION_WORLDWIDE,
    AREA_DESTINATION_ONLY_EUROPE,
    MVPLEASINGCARRETURN
};
